<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [hasContextMenuPermissions]="hasContextMenuPermissions" [contextMenuOptions]="contextMenuOptions"
    [responseArrayCallback]="responseArrayCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
    [rowClassRules]="rowClassRules" [updateStatusType]="updateStatusType">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="organization-settings-add-new-content-block-button"
        class="secondary-button" (click)="addNewContentBlock()" *ngIf="!hasExcludedContentViewPermissions">
        <i class="fa fa-plus"></i>New Content Block ...
    </button>
</ng-template>